import {
  Control,
  Controller,
  ControllerProps,
  FieldError,
  Merge,
} from "react-hook-form";
import { Subject, getSubjectText } from "../../../domains/subject.enum";
import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";

type SubjectCheckboxesProps = {
  error: Merge<FieldError, FieldError[]>;
  control: Control<any>;
} & Partial<Omit<ControllerProps, "control">>;

export const SubjectsCheckboxes = ({
  error,
  control,
  ...props
}: SubjectCheckboxesProps) => {
  return (
    <Controller
      name="subjects"
      control={control}
      defaultValue={[]}
      render={({ field: props }) => (
        <>
          {[
            Subject.JAPANESE,
            Subject.MATHEMATICS,
            Subject.SCIENCE,
            Subject.SOCIALSTUDIES,
          ].map((subject) => (
            <FormControlLabel
              label={getSubjectText(subject)}
              control={
                <Checkbox
                  {...props}
                  key={subject}
                  checked={props.value.includes(subject)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      return props.onChange([...props.value, subject]);
                    } else {
                      return props.onChange(
                        props.value.filter((removed) => removed !== subject)
                      );
                    }
                  }}
                />
              }
            />
          ))}
          <FormHelperText error={!!error} sx={{ textAlign: "center" }}>
            {typeof error?.message === "string"
              ? error.message
              : "科目を選択してください"}
          </FormHelperText>
        </>
      )}
      {...props}
    />
  );
};
